import { ScrollRestoration } from 'react-router-dom';
import { ReferralQueryRoot } from '@/features/referral/ReferralQueryRoot';
import { NotifyProvider } from '@/shell/NotifyProvider';
import { RouteFocus } from '@/shell/RouteFocus';

/**
 * The root route's element. `ScrollRestoration` (a data-router feature: `createBrowserRouter`
 * supports it) puts a list back where it was on Back (NAV-011) and starts a new page at the top;
 * in-page view changes (`useUrlState`) opt out with `preventScrollReset`. `RouteFocus`
 * (TMMAPP-0072) then moves focus to the new page's `h1` on a path change — after the page tree's
 * own effects (it is the page's later sibling) and without scrolling.
 *
 * `NotifyProvider` wraps the outlet (`ReferralQueryRoot`) so a toast survives navigation,
 * including screens outside `AppShell` (genesis, profile refetch).
 */
export function RootLayout() {
  return (
    <NotifyProvider>
      <ReferralQueryRoot />
      <ScrollRestoration />
      <RouteFocus />
    </NotifyProvider>
  );
}
